import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";
import ActionBar from "../components/ActionBar";
import AlertDialog from "../components/AlertDialog";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";

import VLComponent from "./VLComponent";

class AboutScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, events: []};
    }

    componentDidMount() {
        API.POST("account/getInfo", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                this.setState(result.result);
                this.setState({loaded: true});
            }
        });
    }

    MIT = (copyright) => {
        return <div>MIT License<br/><br/>

            Copyright (c) {copyright}.<br/><br/>

            Permission is hereby granted, free of charge, to any person obtaining a copy
            of this software and associated documentation files (the "Software"), to deal
            in the Software without restriction, including without limitation the rights
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software is
            furnished to do so, subject to the following conditions:<br/><br/>

            The above copyright notice and this permission notice shall be included in all
            copies or substantial portions of the Software.<br/><br/>

            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.</div>;
    };

    licenses = () => {
        return <div>
            <h2>Open Source Licenses</h2>
            <p><b>React</b></p>
            <p>{this.MIT("Facebook, Inc. and its affiliates")}</p>
            <p><b>Material UI</b></p>
            <p>{this.MIT("2014 Call-Em-All")}</p>
            <p><b>react-router-component</b></p>
            <p>{this.MIT("2013 Andrey Popp")}</p>
            <p><b>Moment JS</b></p>
            <p>{this.MIT("JS Foundation and other contributors")}</p>
            <p><b>React Twitter Embed</b></p>
            <p>{this.MIT("saurabhnemade 2018")}</p>
            <p><b>React Magnifier</b></p>
            <p>{this.MIT("2018 Samuel Meuli")}</p>
            <p><b>Pikaday</b></p>
            <p>{this.MIT("2014 David Bushell")}</p>
            <p><b>Segmented Control</b></p>
            <p>{this.MIT("2016 by Loren Sands-Ramshaw")}</p>
            <p><b>Segmented Control CSS</b></p>
            <p>{this.MIT("2016 by François St-Germain (http://codepen.io/fstgerm/pen/Jafyj)")}</p>
        </div>;
    };

    render() {
        return (
            <div>
                <AlertDialog open={this.state.showingLicenses} content={this.licenses} positive="Dismiss"
                             action={() => this.setState({showingLicenses: false})} size="md"/>
                <ActionBar title="About"/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    padding: 16
                }}>
                    <Paper style={{width: "50vw", padding: 16, textAlign: "center"}}>
                        <h1><b>Vision Link Web Portal</b></h1>
                        <img src={this.state.app_image}
                             style={{maxHeight: "20vh", maxWidth: "20vw", marginTop: 30}}/><br/>
                        <img src="https://api.vision-link.co.uk/app_logo/VL.png"
                             style={{maxHeight: "20vh", maxWidth: "20vw", marginTop: 30}}/><br/><br/>
                        <p style={{fontWeight: 800, fontSize: 20}}>Version 1.0</p>
                        <VLButton title="www.vision-link.co.uk" onClick={() => window.open("https://www.vision-link.co.uk")}/><br/>                       
                        <br/> <br/>
                    </Paper><br/> <br/><br/> <br/>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

}

export default AboutScreen;
